import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { FilterPageProps, ListProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { BrandVerticalReport_brandDetails_edges_node } from "../../types/BrandVerticalReport";
import { BrandVerticalList } from "../BrandVerticalList";
import {
  BrandVerticalsFilterKey,
  BrandVerticalsFilterOpts,
  createFilterStructure
} from "./filters";

export interface BrandVerticalListPageProps
  extends ListProps,
    FilterPageProps<BrandVerticalsFilterKey, BrandVerticalsFilterOpts>,
    TabPageProps {
  brandVerticals: BrandVerticalReport_brandDetails_edges_node[];
  onBack: () => void;
  download: () => void;
}

export const BrandVerticalListPage: React.FC<BrandVerticalListPageProps> = ({
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  brandVerticals,
  currencySymbol,
  onBack,
  download,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);
  return (
    <>
      <Container>
        <AppHeader onBack={onBack}>
          {intl.formatMessage({
            defaultMessage: "Reports",
            description: "reports"
          })}
        </AppHeader>
        <PageHeader title="Brand Verticals">
          <Button
            color="primary"
            variant="contained"
            disabled={!brandVerticals}
            onClick={download}
          >
            Download
          </Button>
        </PageHeader>

        <Card>
          <FilterBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All",
              description: "tab name"
            })}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            tabs={tabs}
            filterStructure={structure}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search by Brand Name or Legal Name"
            })}
            initialSearch={initialSearch}
            onSearchChange={onSearchChange}
            onFilterChange={onFilterChange}
            onAll={onAll}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />

          <BrandVerticalList brandVerticals={brandVerticals} {...listProps} />
        </Card>
      </Container>
    </>
  );
};

export default BrandVerticalListPage;
